import React from 'react';

const AdaptiveIcon = ({ className = "" }) => (
  <svg className={className} width="100" height="100" viewBox="0 0 100 100" fill="none">
    <path d="M50 20 L 60 40 L 80 40 L 65 55 L 72 75 L 50 62 L 28 75 L 35 55 L 20 40 L 40 40 Z" 
          stroke="currentColor" strokeWidth="3" fill="none"/>
    <circle cx="50" cy="50" r="8" fill="currentColor"/>
  </svg>
);

export default AdaptiveIcon;